<template>
  <div class="app-loader">
    <div class="preloader__cube bounce">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="95"
        height="108"
        viewBox="0 0 95 108"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M93.8161 28.0536V80.1609L47.408 106.215L1 80.1609V28.0536L47.408 2L93.8161 28.0536Z"
          fill="#0000FF"
        />
        <path
          d="M47.6528 1.56401L47.408 2L47.408 2L47.6528 1.56401ZM47.408 1.42659L47.6528 0.990603L47.408 0.853189L47.1633 0.990603L47.408 1.42659ZM94.0609 27.6176L94.4968 27.8624L94.7416 27.4264L94.3056 27.1817L94.0609 27.6176ZM93.5713 28.4896L93.3266 28.9256L93.7626 29.1704L94.0073 28.7344L93.5713 28.4896ZM47.408 2.5734L47.6528 2.13741L47.408 2L47.1633 2.13741L47.408 2.5734ZM1.24477 28.4896L0.808776 28.7344L1.05354 29.1704L1.48953 28.9256L1.24477 28.4896ZM0.755233 27.6176L0.510465 27.1817L0.0744731 27.4264L0.319241 27.8624L0.755233 27.6176ZM47.1633 1.56401L47.408 2L47.4081 2L47.1633 1.56401ZM93.3161 28.0536V27.5536H92.8161V28.0536H93.3161ZM93.3161 79.8682L93.5609 80.3042L93.8161 80.1609V79.8682H93.3161ZM94.3161 28.0536H94.8161V27.5536H94.3161V28.0536ZM94.3161 80.4536L94.5609 80.8896L94.8161 80.7463V80.4536H94.3161ZM94.0609 80.5969L93.8161 80.1609L94.0609 80.5969ZM47.6528 106.651L47.2168 106.895L47.4616 107.331L47.8976 107.087L47.6528 106.651ZM47.1633 105.779L46.9185 105.343L46.4825 105.587L46.7273 106.023L47.1633 105.779ZM93.5713 27.6176L94.0073 27.3729L93.7626 26.9369L93.3266 27.1817L93.5713 27.6176ZM47.1633 53.6713L46.9185 53.2353L46.4825 53.4801L46.7273 53.9161L47.1633 53.6713ZM94.0609 28.4896L94.3056 28.9256L94.7416 28.6809L94.4968 28.2449L94.0609 28.4896ZM47.6528 54.5433L47.2168 54.788L47.4616 55.224L47.8976 54.9793L47.6528 54.5433ZM1.5 79.8682H1V80.1609L1.25523 80.3042L1.5 79.8682ZM1.5 28.0536H2V27.5536H1.5V28.0536ZM0.5 28.0536V27.5536H0V28.0536H0.5ZM0.5 80.4536H0V80.7463L0.255234 80.8896L0.5 80.4536ZM0.755233 80.5969L1 80.1609H0.999999L0.755233 80.5969ZM47.1633 106.651L46.9185 107.087L47.3545 107.331L47.5993 106.895L47.1633 106.651ZM47.6528 105.779L48.0888 106.023L48.3336 105.587L47.8976 105.343L47.6528 105.779ZM47.908 106.215V106.715H48.408V106.215H47.908ZM47.908 54.1073H48.408V53.6073H47.908V54.1073ZM46.908 106.215H46.408V106.715H46.908V106.215ZM46.908 54.1073V53.6073H46.408V54.1073H46.908ZM0.755233 28.4896L0.319241 28.2449L0.0744731 28.6809L0.510465 28.9256L0.755233 28.4896ZM47.1633 54.5433L46.9185 54.9793L47.3545 55.224L47.5993 54.788L47.1633 54.5433ZM1.24477 27.6176L1.48953 27.1817L1.05354 26.9369L0.808776 27.3729L1.24477 27.6176ZM47.6528 53.6713L48.0888 53.9161L48.3336 53.4801L47.8976 53.2353L47.6528 53.6713ZM47.8976 1.12802L47.6528 0.990603L47.1633 1.86259L47.408 2L47.8976 1.12802ZM94.3056 27.1817L47.8976 1.12802L47.408 2L93.8161 28.0536L94.3056 27.1817ZM94.0073 28.7344L94.4968 27.8624L93.6249 27.3729L93.1353 28.2449L94.0073 28.7344ZM47.1633 3.0094L93.3266 28.9256L93.8161 28.0536L47.6528 2.13741L47.1633 3.0094ZM1.48953 28.9256L47.6528 3.0094L47.1633 2.13741L1 28.0536L1.48953 28.9256ZM0.319241 27.8624L0.808776 28.7344L1.68076 28.2449L1.19122 27.3729L0.319241 27.8624ZM46.9185 1.12802L0.510465 27.1817L1 28.0536L47.408 2L46.9185 1.12802ZM47.1633 0.990603L46.9185 1.12802L47.4081 2L47.6528 1.86259L47.1633 0.990603ZM92.8161 28.0536V79.8682H93.8161V28.0536H92.8161ZM94.3161 27.5536H93.3161V28.5536H94.3161V27.5536ZM94.8161 80.1609V28.0536H93.8161V80.1609H94.8161ZM94.8161 80.4536V80.1609H93.8161V80.4536H94.8161ZM94.3056 81.0329L94.5609 80.8896L94.0713 80.0176L93.8161 80.1609L94.3056 81.0329ZM47.8976 107.087L94.3056 81.0329L93.8161 80.1609L47.408 106.215L47.8976 107.087ZM46.7273 106.023L47.2168 106.895L48.0888 106.406L47.5993 105.534L46.7273 106.023ZM93.0713 79.4322L46.9185 105.343L47.408 106.215L93.5609 80.3042L93.0713 79.4322ZM93.3266 27.1817L46.9185 53.2353L47.408 54.1073L93.8161 28.0536L93.3266 27.1817ZM94.4968 28.2449L94.0073 27.3729L93.1353 27.8624L93.6249 28.7344L94.4968 28.2449ZM47.8976 54.9793L94.3056 28.9256L93.8161 28.0536L47.408 54.1073L47.8976 54.9793ZM46.7273 53.9161L47.2168 54.788L48.0888 54.2985L47.5993 53.4265L46.7273 53.9161ZM2 79.8682V28.0536H1V79.8682H2ZM1.5 27.5536H0.5V28.5536H1.5V27.5536ZM0 28.0536V80.1609H1V28.0536H0ZM0 80.1609V80.4536H1V80.1609H0ZM0.255234 80.8896L0.510466 81.0329L0.999999 80.1609L0.744766 80.0176L0.255234 80.8896ZM0.510465 81.0329L46.9185 107.087L47.408 106.215L1 80.1609L0.510465 81.0329ZM47.5993 106.895L48.0888 106.023L47.2168 105.534L46.7273 106.406L47.5993 106.895ZM47.8976 105.343L1.74477 79.4322L1.25523 80.3042L47.408 106.215L47.8976 105.343ZM48.408 106.215V54.1073H47.408V106.215H48.408ZM46.908 106.715H47.908V105.715H46.908V106.715ZM46.408 54.1073V106.215H47.408V54.1073H46.408ZM47.908 53.6073H46.908V54.6073H47.908V53.6073ZM0.510465 28.9256L46.9185 54.9793L47.408 54.1073L1 28.0536L0.510465 28.9256ZM0.808776 27.3729L0.319241 28.2449L1.19122 28.7344L1.68076 27.8624L0.808776 27.3729ZM47.8976 53.2353L1.48953 27.1817L1 28.0536L47.408 54.1073L47.8976 53.2353ZM47.5993 54.788L48.0888 53.9161L47.2168 53.4265L46.7273 54.2985L47.5993 54.788Z"
          fill="black"
        />
      </svg>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    name: "App-Loader",
  });
</script>

<style lang="scss">
  .app-loader {
    display: flex;
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(209, 209, 209, 0.479);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .section-loader {
    justify-content: center;
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(209, 209, 209, 0.479);
    & > div {
      position: fixed;
      top: 50%;
    }
  }

  .card-loader {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 500px;
  }

  .scroll-loader {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    margin: 150px 0;
    &.loader--transparent {
      opacity: 0.5;
    }
  }

  .preloader__text {
    position: relative;
    z-index: 100;
  }

  .bounce {
    animation-name: bounce-3;
    animation-duration: 1.5s;
    animation-timing-function: ease;
    animation-iteration-count: infinite;
  }

  @keyframes bounce-3 {
    0% {
      transform: translateY(0);
    }

    50% {
      transform: translateY(-3vh);
    }

    100% {
      transform: translateY(0);
    }
  }
  .preloader {
    display: block !important;
    &__text {
      text-align: center;
    }
  }
</style>
